export const backPageTarget = '[data-back-page]';
export const emailTarget = '[data-email]';

// Navigation
export const navDesktopComponentTarget = '[data-navigation-desktop]';
export const navMobileComponentTarget = '[data-navigation-mobile]';
export const navigationDropdownComponent = '[data-sub-menu-modal]';

// modal keyword search 
export const searchKeywordTarget = '[data-keyword-search]';

// accordion component
export const accordionTriggerComponentTarget = '[data-accordion-trigger]';
export const accordionContentComponentTarget = '[data-accordion-content]';
export const accordionIconComponentTarget = '[data-accordion-icon]';

// faq component
export const faqComponentTarget = '[data-faq-component]';
export const faqSearchTrigger = '[data-faq-search-trigger]';

// featured module tiles
export const featuredModuleTilesComponent = '[data-featured-module-tiles]'

// anchor sidebox component
export const anchorSideboxComponent = '[data-anchor-sidebox]';
export const anchorSideboxTrigger = '[data-anchor-trigger]';

// carousel
export const testimonialCarousel = '[data-testimonial-carousel]';
export const partnerLogoCarousel = '[data-partner-logo-carousel]';
export const resourcesCarousel = '[data-resources-carousel]';
export const scrollingTextTilesCarousel = '[data-scrolling-text-tiles-carousel]';

// Single Form

export const singleFormContent = '[data-single-form-content]';

// modal component
export const modalContainerTarget = '[data-modal-container]';

// video modal component
export const modalVideoTarget = '[data-modal-video]';

// member listing tiles
export const memberListingTilesComponent = '[data-member-listing-tiles]';
export const nationalMembersTrigger = '[data-national-members-trigger]';
export const stateMembersTrigger = '[data-state-members-trigger]';
export const nationalMembersTarget = '[data-national-members]';
export const stateMembersTarget = '[data-state-members]';

// member modal component
export const modalMemberContent = '[data-modal-member-content]';

// Article filter component
export const articleFilterComponent = '[data-search-articles]';

// Article filter component
export const careerFilterComponent = '[data-search-careers]';

// Resources filter component
export const resourcesFilterComponent = '[data-search-resources]';
export const resourcesFilterKeywordSearch ='[data-keyword-search]'
export const lazyLoadComponent = '[data-show-more]';

// Region State Selector
export const modalRegionTrigger = '[data-region-trigger]';
export const modalRegionComponent = '[data-region-modal]';
export const nswTrigger = '[data-nsw-trigger]';
export const vicTrigger = '[data-vic-trigger]';
export const qldTrigger = '[data-qld-trigger]';
export const actTrigger = '[data-act-trigger]';
export const saTrigger = '[data-sa-trigger]';
export const waTrigger = '[data-wa-trigger]';
export const tasTrigger = '[data-tas-trigger]';
export const ntTrigger = '[data-nt-trigger]';

export const mapKeywordSearchLabels: Map<string, string> = new Map([
	['Teachers & Schools', 'Teachers & Schools'],
	['Families', 'Families'],
	['News', 'News'],
	['Careers', 'Careers'],
]);

export const mapPostTypeLabels: Map<string, string> = new Map([
	['Pages', 'Page'],
]);



// WEBPACK FOOTER //
// ./scripts/components/index.ts